<template>
  <header class="header_container">
    <div class="container-fluid">
      <div class="header_content">
        <div class="header_logo_wrapper">
          <div class="header_logo_container">
            <router-link to="/" class="header_item d-flex">
              <img src="@/assets/img/logo.png" class="img-fluid" width="100" alt="logo-white" title="logo-white" />
              <!--   <span class="ms-2 clr-red-froly fnt-15">Live Connect</span> -->
            </router-link>
          </div>
          <div v-click-outside="handleOutSide" class="header_menu_wrapper">
            <div class="header_menu_container" @click.prevent="is_menu = !is_menu">
              <div class="header_item d-flex align-items-center" :class="{ show: is_menu }">
                <span class="me-1"><i class="fa fa-bars color"></i></span>
                <span class="title">Menu</span>
              </div>
            </div>
            <div v-if="menuitems?.length" class="header_drop_down dropdown-menu" :class="{ show: is_menu, mobile: $device?.mobile }">
              <div class="user_menu_container">
                <div class="menu_parent_item">
                  <div class="menu_items" @click.prevent="active_menu_parent = item" v-for="item in menuitems" :key="item.name" :class="{ active: active_menu_parent?.name == item.name }">
                    <div class="menu_name">
                      <icon class="me-2" :icon="item.icon" />
                      <div>{{ item.name }}</div>
                    </div>
                    <span class="menu_arrow_icon">
                      <i class="fi fi-angle-right"></i>
                    </span>
                  </div>
                </div>
                <div v-if="active_menu_parent" class="menu_child_items">
                  <keep-alive class="menu_items pos-r" v-for="child in active_menu_parent?.child?.filter((val) => val.is_visible)" :key="child.name">
                    <router-link class="menu_child_item" :to="child.page_url">
                      {{ child.name }}
                    </router-link>
                  </keep-alive>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="header_action_wrapper">
          <!--  <div class="header_action_items">
            <div class="header_item">
              <router-link to="/manage-menu" class="fnt-12 p-0"><i class="fa fa-gear me-2"></i>Admin</router-link>
            </div>
          </div> -->
          <!--   <div v-click-outside="messageOutSideClick" class="header_action_items m-0">
            <div class="header_messages">
              <div @click="is_notification = !is_notification" class="header_item d-flex align-items-center pos-r" :class="{ show: is_notification }">
                <i class="fa-regular fa-message clr-teal-dark"></i>
              </div>
            </div>
          </div> -->
          <div v-click-outside="notifyOutSideClick" class="header_action_items">
            <div class="header_notification">
              <div @click="is_notification = !is_notification" class="header_item d-flex align-items-center pos-r" :class="{ show: is_notification }">
                <i class="far fa-bell fnt-12"></i>
                <span class="pos-a notification_count">99+</span>
              </div>
              <div class="notification_container header_drop_down dropdown-menu" :class="{ show: is_notification, mobile: $device?.mobile }">
                <label class="title"><span class=""> 30 Unread </span>Notifications</label>
                <div class="notify_list_items">
                  <div class="list_item" v-for="item in 10" :key="item">
                    <div class="icon booked"><i class="fa fa-plane-departure"></i></div>
                    <div class="content">
                      <div class="title">Delhi - Mumbai, 23-09-2023, 26 Seats Booked by <span class="highlight">dpauls</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-click-outside="settingOutSideClick" class="header_action_items">
            <div class="header_my_account">
              <div @click="is_setting = !is_setting" class="header_item d-flex align-items-center" :class="{ show: is_setting }">
                <i v-if="!user?.logo" class="fi fi-person"></i>
                <img class="logo" v-else :src="user?.logo" />
                <span class="ms-1">{{ user?.name }}</span>
              </div>
            </div>
            <div class="header_drop_down my_profile dropdown-menu" :class="{ show: is_setting }">
              <ul class="menu_parent">
                <li class="list_heading">
                  <span class="list_label">Your Actions</span>
                </li>
                <li class="navSubmenu">
                  <router-link to="/view/profiles" class="link">
                    <span><i class="fi fi-person fnt-12 me-1"></i> My Profile</span>
                  </router-link>
                </li>
                <!--  <li class="list_heading">
                  <span class="list_label">Admin</span>
                </li>
                <li class="navSubmenu">
                  <router-link to="/admin/users" class="link">
                    <span><i class="fa fa-users fnt-12 me-1"></i> Manage Users</span>
                  </router-link>
                </li>
                <li class="navSubmenu">
                  <router-link to="/admin/menus" class="link">
                    <span><i class="fa fa-gear fnt-12 me-1"></i> Manage Menus</span>
                  </router-link>
                </li>
                <li class="navSubmenu">
                  <router-link to="/admin/airlines" class="link">
                    <span><i class="fa fa-plane fnt-12 me-1"></i> Airlines</span>
                  </router-link>
                </li>
                <li class="navSubmenu">
                  <router-link to="/admin/cruise" class="link">
                    <span><i class="fa fa-ship fnt-12 me-1"></i> Cruise</span>
                  </router-link>
                </li>
                <li class="navSubmenu">
                  <router-link to="/admin/sectors" class="link">
                    <span><i class="fa fa-flag fnt-12 me-1"></i> Sectors</span>
                  </router-link>
                </li>
                <li class="navSubmenu">
                  <router-link to="/admin/countries" class="link">
                    <span><i class="fa fa-map fnt-12 me-1"></i> Countries</span>
                  </router-link>
                </li>
                <li class="navSubmenu">
                  <router-link to="/admin/settings" class="link">
                    <span><i class="fa fa-gears fnt-12 me-1"></i> Settings</span>
                  </router-link>
                </li> -->
                <li class="list_heading">
                  <span class="list_label">Theme Option</span>
                </li>
                <li class="navSubmenu px-2">
                  <div class="d-flex align-items-center justify-content-between w-100">
                    <div><i class="fa-solid fa-laptop me-1"></i> System</div>
                    <div>
                      <div class="form-check form-switch">
                        <input @change.prevent="onChangeSystemTheme" :checked="user?.settings?.theme == 'system'" class="form-check-input" type="checkbox" />
                      </div>
                    </div>
                  </div>
                </li>
                <li v-if="user?.settings?.theme != 'system'" class="navSubmenu px-2">
                  <div class="d-flex align-items-center justify-content-between w-100">
                    <div><i class="far fa-moon me-1"></i>Dark</div>
                    <div>
                      <div class="form-check form-switch">
                        <input @change.prevent="onChangeTheme" class="form-check-input" :checked="user?.settings?.theme == 'dark'" type="checkbox" />
                      </div>
                      <!--  <label class="dp-switch">
                        <input @change.prevent="onChangeTheme" :checked="user?.settings?.theme == 'dark'" type="checkbox" id="dark-theme" />
                        <span class="switch-slider round"></span>
                      </label> -->
                    </div>
                  </div>
                </li>
                <li class="list_heading">
                  <span class="list_label">Others</span>
                </li>
                <li @click.prevent="handleSignOutUser" class="navSubmenu">
                  <a class="link">
                    <span><i class="fa-solid fa-power-off fnt-12 me-1"></i>Log out</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Icon from "@/components/ui/icons";
export default {
  name: "Headers",
  components: { Icon },
  data() {
    return {
      is_setting: false,
      is_menu: false,
      is_notification: false,
      is_messages: false,
      active_menu_parent: null
    };
  },
  methods: {
    ...mapActions({
      changeTheme: "users/changeTheme",
      fetch_current_user: "auth/fetchCurrentUser"
    }),
    settingOutSideClick() {
      this.is_setting = false;
    },
    notifyOutSideClick() {
      this.is_notification = false;
    },
    messageOutSideClick() {
      this.is_messages = false;
    },
    onChangeTheme($event) {
      const theme = $event.currentTarget.checked ? "dark" : "light";
      /*  const _bodyClass = this.$_.head(document.body.className.match(/[\w]+-theme/i));
      document.querySelector("body").classList.replace(_bodyClass, `${theme}-theme`); */
      this.changeTheme(theme);
    },
    onChangeSystemTheme($event) {
      const theme = $event.currentTarget.checked ? "system" : "dark";
      /*  const _bodyClass = this.$_.head(document.body.className.match(/[\w]+-theme/i));
      document.querySelector("body").classList.replace(_bodyClass, `${theme}-theme`); */
      this.changeTheme(theme);
    },
    handleOutSide() {
      this.is_menu = false;
      this.active_menu_parent = null;
    },
    handleSignOutUser() {
      this.$store.dispatch("auth/logoutUser");
    }
  },
  computed: {
    menuitems() {
      /*    const _menu = [
        {
          name: "Flights",
          icon: "flights",
          child: [
            { name: "Inventory", page: "/flights/inventory" },
            { name: "Bookings", page: "/flights/bookings" },
            { name: "Reports", page: "/flights/reports" }
          ]
        },
        {
          name: "Cruise",
          icon: "cruise",
          child: [
            { name: "Inventory", page: "/cruise/inventory" },
            { name: "Bookings", page: "/cruise/bookings" }
          ]
        }
      ];
      if (this.is_admin) {
        _menu.push({
          name: "Admin",
          icon: "security",
          child: [
            { name: "Manage Users", page: "/admin/users" },
            { name: "Manage Menus", page: "/admin/menus" },
            { name: "Airlines", page: "/admin/airlines" },
            { name: "Suppliers", page: "/admin/suppliers" },
            { name: "Cruise", page: "/admin/cruise" },
            { name: "Airports", page: "/admin/airports" },
            { name: "Countries", page: "/admin/countries" },
            { name: "Settings", page: "/admin/settings" }
          ]
        });
      } */
      return this?.user?.menus || [];
    }
  },
  watch: {
    user(value) {
      const _bodyClass = this.$_.head(document.body.className.match(/[\w]+-theme/i));
      document.querySelector("body").classList.replace(_bodyClass, `${value.settings.theme}-theme`);
    },
    is_menu(value) {
      if (value) {
        const parentData = this.menuitems.reduce((obj, data) => {
          const findChild = data.child.find((val) => val.page_url.toLowerCase() === this.$route.path.toLowerCase());
          if (findChild) {
            obj = data;
          }
          return obj;
        }, null);
        if (parentData) {
          this.active_menu_parent = parentData;
        }
      }
    },
    $route() {
      this.is_setting = false;
      this.is_menu = false;
      this.active_menu_parent = null;
    }
  }
};
</script>

<style lang="scss">
.notification_container {
  display: none;
  &.show {
    position: absolute;
    display: flex;
  }
}
</style>